const ua = window.navigator.userAgent.toLowerCase();

const showOverlay = /(micromessenger|weibo|douban)/.test(ua);

const showOverlayOrGo = (link) => {
  if ( showOverlay ) {
  // if ( true ) {
    // if (!/iphone|ipad/.test(ua)) {
    //   $('.ua-browser').html('在浏览器中打开');
    // }
    const $wechat_overlay = $('.wechat-overlay');
    $wechat_overlay.show();
  } else {
    window.location.href = link;
  }
}

export { showOverlayOrGo, showOverlay };